var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-product-tile__colors-wrapper",
      class: { "--is-hovered": _vm.hover },
    },
    [
      _vm.isLoading && _vm.isPlpExclusive
        ? _c(
            "div",
            [
              _c(
                "swiper",
                {
                  ref: "swiper",
                  staticClass: "rb-product-tile__images-carousel",
                },
                _vm._l(6, function (i) {
                  return _c(
                    "swiper-slide",
                    {
                      key: i,
                      staticClass:
                        "rb-product-tile-images-carousel__image --skeleton-swiper",
                    },
                    [
                      _c("rb-dummy-skeleton", {
                        staticClass: "--image-skeleton",
                        attrs: { icon: "assets" },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.colorsSelectorIsVisible
        ? _c(
            "div",
            { staticClass: "rb-product-tile__colors --no-click" },
            [
              _c("rb-product-tile-colors-selector", {
                attrs: {
                  colors: _vm.colors,
                  "selected-index": _vm.selectedIndex,
                  category: _vm.category,
                  "is-plp-exclusive": _vm.isPlpExclusive,
                },
                on: { "update:change-variant": _vm.selectIndex },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "rb-btn__wrapper",
          class: {
            "--padding-bottom": _vm.isPlpExclusive,
            "--padding-top": _vm.colorsSelectorIsVisible,
            "--no-colors": !_vm.colorsSelectorIsVisible,
          },
        },
        [
          _vm.isPlpExclusive
            ? _c(
                "button",
                {
                  staticClass: "rb-btn rb-btn--red",
                  attrs: { "data-description": _vm.dataDescriptionCustomize },
                  on: { click: _vm.addToBag },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("common.shop_now")) + "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.isMobile &&
      _vm.colors.length > 1 &&
      !_vm.isLoading &&
      !_vm.isPlpExclusive
        ? _c("rb-swiper-bar", {
            attrs: { index: _vm.selectedIndex, "max-index": _vm.colors.length },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading && !_vm.isPlpExclusive
        ? _c("rb-dummy-skeleton", { staticClass: "--swiper-bar" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }